import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { IconShipmentCheck } from '@cimpress-technology/react-streamline-icons';
import { Label } from '../Label';

const meta: Meta<typeof Label> = {
  title: 'Components/Label',
  component: Label,
};

export default meta;
type Story = StoryObj<typeof Label>;

export const Default: Story = {
  args: {
    text: 'Label',
  },
};

export const SizeVariants: Story = {
  render: () => (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      <Label text="Small" size="sm" />
      <Label text="Default" size="default" />
      <Label text="Large" size="lg" />
    </div>
  ),
};

export const StatusVariants: Story = {
  render: () => (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      <Label text="Default" status="default" />
      <Label text="Danger" status="danger" />
      <Label text="Info" status="info" />
      <Label text="Primary" status="primary" />
      <Label text="Success" status="success" />
      <Label text="Warning" status="warning" />
    </div>
  ),
};

export const WithIcon: Story = {
  args: {
    text: (
      <span style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <IconShipmentCheck /> Label
      </span>
    ),
  },
};
